export default [
    {
        path: 'alto-custo-gerenciamento-processo',
        component: () => import(
            /* webpackChunkName: 'farmacia-alto-custo-gerenciamento-processo' */
            '@/views/farmacia/alto-custo-gerenciamento-processo/Index'
        ),
        redirect: 'alto-custo-gerenciamento-processo/index',
        children: [
            {
                name: 'farmacia-alto-custo-gerenciamento-processo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-alto-custo-gerenciamento-processo' */
                    '@/views/farmacia/alto-custo-gerenciamento-processo/List.vue'
                ),
            },
            {
                name: 'farmacia-alto-custo-gerenciamento-processo-create',
                path: 'create/:pacienteId',
                props: route => ({ pacienteId: parseInt(route.params.pacienteId) }),
                component: () => import(
                    /* webpackChunkName: 'farmacia-alto-custo-gerenciamento-processo' */
                    '@/views/farmacia/alto-custo-gerenciamento-processo/Form.vue'
                ),
            },
            {
                name: 'farmacia-alto-custo-gerenciamento-processo-edit',
                path: 'edit/:pacienteId/:id',
                props: route => ({ pacienteId: parseInt(route.params.pacienteId), id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'farmacia-alto-custo-gerenciamento-processo' */
                    '@/views/farmacia/alto-custo-gerenciamento-processo/Form.vue'
                ),
            },
        ],
    },
]